import Layout from '@/layout';

export default {
  path: '/air-monitor',
  redirect: '/air-monitor/monitor/home',
  component: Layout,
  meta: {
    title: '人防监测',
    icon: 'iconfont icon-home',
    code: '010214',
    activeMenu: '/air-monitor'
  },
  children: [
    {
      path: 'monitor',
      name: 'AirMonitor',
      component: () => import('@/views/air-monitor/index.vue'),
      meta: {
        activeMenu: '/air-monitor',
        noPadding: true
      },
      children: [
        {
          path: 'home',
          name: 'AirMonitorHome',
          component: () => import('@/views/air-monitor/home/index.vue'),
          meta: {
            activeMenu: 'AirMonitorHome',
            hidden: true,
            noPadding: true
          },
          children: [
            {
              path: 'scene',
              name: 'AirMonitorHomeScene',
              component: () => import('@/views/air-monitor/home/scene.vue'),
              meta: {
                activeMenu: 'AirMonitorHome',
                hidden: true,
                noPadding: true
              }
            },
            {
              path: 'device',
              name: 'AirMonitorHomeDevice',
              component: () => import('@/views/air-monitor/home/device.vue'),
              meta: {
                activeMenu: 'AirMonitorHome',
                hidden: true,
                noPadding: true
              }
            }
          ]
        },
        // {
        //   path: 'disposal',
        //   name: 'AirMonitorDisposal',
        //   component: () => import('@/views/air-monitor/disposal/index.vue'),
        //   meta: {
        //     activeMenu: '/air-monitor',
        //     hidden: true,
        //     noPadding: true
        //   }
        // },
        // 报警信息
        {
          path: 'alarmInfo',
          name: 'AirMonitorAlarmInfo',
          component: () => import('@/views/air-monitor/alarmCenter/alarm.vue'),
          meta: {
            activeMenu: 'AirMonitorAlarmCenter',
            hidden: true,
            noPadding: true
          }
        },
        // 事件信息
        {
          path: 'event',
          name: 'AirMonitorEventInfo',
          component: () => import('@/views/air-monitor/alarmCenter/event.vue'),
          meta: {
            activeMenu: 'AirMonitorAlarmCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'personnel',
          name: 'AirMonitorPersonnelManage',
          component: () => import('@/views/air-monitor/emergencyCenter/personnel.vue'),
          meta: {
            activeMenu: 'AirMonitorEmergencyCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'expert',
          name: 'AirMonitorExpertManage',
          component: () => import('@/views/air-monitor/emergencyCenter/expert.vue'),
          meta: {
            activeMenu: 'AirMonitorEmergencyCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'plan',
          name: 'AirMonitorPlanManage',
          component: () => import('@/views/air-monitor/emergencyCenter/plan.vue'),
          meta: {
            activeMenu: 'AirMonitorEmergencyCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'materials',
          name: 'AirMonitorMaterialsManage',
          component: () => import('@/views/air-monitor/emergencyCenter/materials.vue'),
          meta: {
            activeMenu: 'AirMonitorEmergencyCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'dangerousGoodsInfo',
          name: 'AirMonitorDangerousGoodsInfo',
          component: () =>
            import('@/views/air-monitor/informationCenter/dangerousGoodsInfo/index.vue'),
          meta: {
            activeMenu: 'AirMonitorInformationCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'logInfo',
          name: 'AirMonitorLogInfo',
          component: () => import('@/views/air-monitor/informationCenter/logInfo/index.vue'),
          meta: {
            activeMenu: 'AirMonitorInformationCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'monitoringData',
          name: 'AirMonitorMonitoringData',
          component: () => import('@/views/air-monitor/deviceCenter/monitoringData.vue'),
          meta: {
            activeMenu: 'AirMonitorDeviceCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'maintenanceInfo',
          name: 'AirMonitorMaintenanceInfo',
          component: () => import('@/views/air-monitor/deviceCenter/maintenanceInfo.vue'),
          meta: {
            activeMenu: 'AirMonitorDeviceCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'faultInfo',
          name: 'AirMonitorFaultInfo',
          component: () => import('@/views/air-monitor/deviceCenter/faultInfo.vue'),
          meta: {
            activeMenu: 'AirMonitorDeviceCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'deviceInfo',
          name: 'AirMonitorDeviceInfo',
          component: () => import('@/views/air-monitor/deviceCenter/deviceInfo.vue'),
          meta: {
            activeMenu: 'AirMonitorDeviceCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'alarmStat',
          name: 'AirMonitorAlarmStat',
          component: () => import('@/views/air-monitor/statCenter/alarm.vue'),
          meta: {
            activeMenu: 'AirMonitorStatCenter',
            hidden: true,
            noPadding: true
          }
        },
        {
          path: 'eventStat',
          name: 'AirMonitorEventStat',
          component: () => import('@/views/air-monitor/statCenter/event.vue'),
          meta: {
            activeMenu: 'AirMonitorStatCenter',
            hidden: true,
            noPadding: true
          }
        }
      ]
    },
    {
      path: '*',
      component: () => import('@/views/404')
    }
  ]
};
